export default {
    init($){
        console.info('about.js: init');
        // $('.cards-historia .card').each(function() {
        //     $(this).parent().prepend(this);
        // });

        $('.cards-historia').slick({
            slidesToShow: 4,
            slidesToScroll: 4,
            nav: true,
            infinite: false,
            responsive:[
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },

            ]
        });
    }
}